module.exports = __webpack_public_path__ + "img/lookbook_6_center.6b2b0e42.png";